module.exports = __webpack_public_path__ + "media/banquet.ca01d693.jpg";